// extracted by mini-css-extract-plugin
export var actions = "_tw-4";
export var item = "_tw-1";
export var price = "_tw-3";
export var quantity = "_tw-2";
export var table = "_tw-0";